/* ── Hero Tabbed Banners ───────────────────────────────────────────────────
   Replaced the .hp-* accordion on 2026-09-03.
   Timer = one Web Animations API animation on the active tab's .ht-fill
   (clip-path inset 100% -> 0, linear). WAAPI gives pause()/play() for free,
   runs off the main thread, and is interruptible: clicking a tab cancels the
   running fill and starts a fresh one. Tabs before the active one stay full,
   tabs after stay empty, so the rail reads as a timeline.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  var root = document.getElementById('heroTabs');
  if (!root) return;

  /* The site header (#dn-wrap = countdown bar + navbar) is position:fixed, so
     nothing in the page reserves space for it and the banner artwork was being
     clipped. Publish its real height as --dn-header-h and keep it in sync: the
     countdown bar removes itself when the sale ends, changing the height. */
  (function () {
    var wrap = document.getElementById('dn-wrap');
    if (!wrap) return;
    var last = -1;
    function sync() {
      var h = Math.round(wrap.getBoundingClientRect().height);
      if (h > 0 && h !== last) {
        last = h;
        document.documentElement.style.setProperty('--dn-header-h', h + 'px');
      }
    }
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', sync);
    window.addEventListener('load', sync);
    if (typeof ResizeObserver === 'function') { new ResizeObserver(sync).observe(wrap); }
    else { setTimeout(sync, 500); setTimeout(sync, 2000); }
  })();
  var stage  = document.getElementById('htStage');
  var track  = document.getElementById('htTrack');
  var tabsEl = document.getElementById('htTabs');
  var pauseB = document.getElementById('htPause');
  var live   = document.getElementById('htLive');
  var slides = Array.prototype.slice.call(root.querySelectorAll('.ht-slide'));
  var tabs   = Array.prototype.slice.call(root.querySelectorAll('.ht-tab'));
  if (!slides.length || slides.length !== tabs.length) return;
  var fills  = tabs.map(function (t) { return t.querySelector('.ht-fill'); });
  var amb    = Array.prototype.slice.call(root.querySelectorAll('.ht-ambient img'));
  var ambOn  = 0;
  var n      = slides.length;

  /* Read --slide-dur defensively. Shopify's CSS minifier rewrites `6000ms`
     into `6s`, and parseInt('6s') is 6 鈥?a 6ms slide, which flickers. Parse
     the unit explicitly and reject anything implausible. */
  function readDur(varName, fallback) {
    var raw = (getComputedStyle(root).getPropertyValue(varName) || '').trim();
    var m = /^([0-9]*\.?[0-9]+)\s*(ms|s)?$/i.exec(raw);
    if (!m) return fallback;
    var num = parseFloat(m[1]);
    if (!isFinite(num)) return fallback;
    var ms = (m[2] && m[2].toLowerCase() === 's') ? num * 1000 : num;
    return (ms >= 500 && ms <= 60000) ? ms : fallback;
  }
  var DUR       = readDur('--slide-dur', 6000);
  var reduce    = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var hasWAAPI  = typeof Element.prototype.animate === 'function';

  var active = 0;
  var anim   = null;
  var userPaused  = false;
  var hoverPaused = false;

  var FULL  = 'inset(0 0 0 0)';
  var EMPTY = 'inset(0 100% 0 0)';

  function settleFills(i) {
    fills.forEach(function (f, j) {
      if (j === i || !f) return;
      if (f.getAnimations) { f.getAnimations().forEach(function (a) { a.cancel(); }); }
      f.style.clipPath = j < i ? FULL : EMPTY;
    });
  }

  function runTimer() {
    if (anim) { anim.onfinish = null; anim.cancel(); anim = null; }
    var f = fills[active];
    if (!f) return;
    f.style.clipPath = '';
    if (hasWAAPI) {
      anim = f.animate(
        [{ clipPath: EMPTY }, { clipPath: FULL }],
        { duration: DUR, easing: 'linear', fill: 'forwards' }
      );
      anim.onfinish = function () { go(active + 1); };
    } else {
      f.style.clipPath = FULL;
      anim = { pause: function () {}, play: function () {}, cancel: function () { clearTimeout(this.t); }, onfinish: null };
      anim.t = setTimeout(function () { go(active + 1); }, DUR);
    }
    syncPlayState();
  }

  function syncPlayState() {
    if (!anim) return;
    var shouldPause = userPaused || hoverPaused || document.hidden;
    if (shouldPause) anim.pause(); else anim.play();
  }

  /* Ambient backdrop follows the active banner (two layers crossfade).
     The 240px tab thumbnail is plenty: the layer is blurred 48px anyway, and
     blurring a 1920px image on every change is what freezes low-end GPUs. */
  function setAmbient(i) {
    if (amb.length < 2) return;
    var thumb = tabs[i].querySelector('.ht-thumb img');
    var src = (thumb || slides[i].querySelector('.ht-img')).getAttribute('src');
    var next = amb[1 - ambOn];
    if (next.getAttribute('src') !== src) next.setAttribute('src', src);
    amb[ambOn].classList.remove('is-on');
    next.classList.add('is-on');
    ambOn = 1 - ambOn;
  }

  function go(i, focusTab) {
    i = ((i % n) + n) % n;
    if (i !== active) {
      slides[active].classList.remove('is-active');
      tabs[active].setAttribute('aria-selected', 'false');
      tabs[active].tabIndex = -1;
      active = i;
      slides[active].classList.add('is-active');
      tabs[active].setAttribute('aria-selected', 'true');
      tabs[active].tabIndex = 0;
      revealTab(tabs[active]);
      setAmbient(active);
      if (live) {
        var title = tabs[active].querySelector('.ht-tab-title').textContent;
        live.textContent = 'Banner ' + (active + 1) + ' of ' + n + ': ' + title;
      }
    }
    if (focusTab) tabs[active].focus({ preventScroll: true });
    settleFills(active);
    runTimer();
  }

  /* Keep the active tab visible when the rail overflows (mobile), without
     scrolling the page the way scrollIntoView can. */
  function revealTab(tab) {
    if (tabsEl.scrollWidth <= tabsEl.clientWidth) return;
    var left = tab.offsetLeft, right = left + tab.offsetWidth;
    var vl = tabsEl.scrollLeft, vr = vl + tabsEl.clientWidth;
    var target = null;
    if (left < vl) target = left - 16;
    else if (right > vr) target = right - tabsEl.clientWidth + 16;
    if (target !== null) tabsEl.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { go(i); });
  });
  tabsEl.addEventListener('keydown', function (e) {
    var handled = true;
    switch (e.key) {
      case 'ArrowRight': go(active + 1, true); break;
      case 'ArrowLeft':  go(active - 1, true); break;
      case 'Home':       go(0, true);          break;
      case 'End':        go(n - 1, true);      break;
      default: handled = false;
    }
    if (handled) e.preventDefault();
  });

  if (pauseB) {
    pauseB.addEventListener('click', function () {
      userPaused = !userPaused;
      pauseB.setAttribute('aria-pressed', String(userPaused));
      pauseB.setAttribute('aria-label', userPaused ? 'Resume auto-rotation' : 'Pause auto-rotation');
      syncPlayState();
    });
  }

  /* Hover pauses — desktop only; touch "hover" is a false positive. */
  if (fineHover) {
    stage.addEventListener('mouseenter', function () { hoverPaused = true;  syncPlayState(); });
    stage.addEventListener('mouseleave', function () { hoverPaused = false; syncPlayState(); });
  }

  /* Background tab: don't burn through banners nobody is watching. */
  document.addEventListener('visibilitychange', syncPlayState);

  /* Touch swipe on the stage. */
  (function () {
    var startX = 0, startT = 0, dx = 0, dragging = false, moved = false;
    var DAMP = 0.35, DIST = 60, VEL = 0.11;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || dragging) return;
      dragging = true; moved = false; dx = 0;
      startX = e.clientX; startT = Date.now();
      track.classList.remove('is-settling');
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      if (!reduce) track.style.transform = 'translateX(' + (dx * DAMP) + 'px)';
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      var dt = Math.max(1, Date.now() - startT);
      var velocity = Math.abs(dx) / dt;
      track.classList.add('is-settling');
      track.style.transform = 'translateX(0)';
      if (Math.abs(dx) >= DIST || (moved && velocity > VEL)) go(dx < 0 ? active + 1 : active - 1);
      try { stage.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    /* A swipe must never also fire the banner link. */
    stage.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  })();

  settleFills(active);
  setAmbient(active);
  runTimer();
})();

/* ── Category Cards — drag scroll ────────────────────────────── */
(function () {
  var track = document.getElementById('catsTrack');
  if (!track) return;
  var isDragging = false, startX = 0, scrollLeft = 0, moved = false;
  track.addEventListener('mousedown', function (e) {
    isDragging = true; moved = false;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
    track.classList.add('dragging');
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    moved = true;
    var x = e.pageX - track.offsetLeft;
    var walk = (x - startX) * 1.5;
    track.scrollLeft = scrollLeft - walk;
  });
  function stopDrag() { isDragging = false; track.classList.remove('dragging'); }
  track.addEventListener('mouseup', stopDrag);
  track.addEventListener('mouseleave', stopDrag);
  /* prevent navigation if user was dragging */
  track.addEventListener('click', function (e) { if (moved) e.preventDefault(); });
})();

/* ── Flash Deals countdown timer ─────────────────────────────────────────── */
(function () {
  var endTime = new Date();
  endTime.setHours(23, 59, 59, 999);
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var now  = new Date();
    var diff = Math.max(0, endTime - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var hEl = document.getElementById('deal-h');
    var mEl = document.getElementById('deal-m');
    var sEl = document.getElementById('deal-s');
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);

  /* Drag-scroll for deals track */
  var dealWrap = document.getElementById('deals-track-wrap');
  if (dealWrap) {
    var isDown = false, startX, scrollLeft;
    dealWrap.addEventListener('mousedown', function (e) {
      isDown = true;
      dealWrap.classList.add('grabbing');
      startX = e.pageX - dealWrap.offsetLeft;
      scrollLeft = dealWrap.scrollLeft;
    });
    document.addEventListener('mouseup', function () {
      isDown = false;
      dealWrap.classList.remove('grabbing');
    });
    dealWrap.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - dealWrap.offsetLeft;
      dealWrap.scrollLeft = scrollLeft - (x - startX);
    });
  }
})();